module.exports = __webpack_public_path__ + "static/jobs-img-6c83ff230545e33f67c0a925c8ce74ff.svg";